<div
  class="flex w-[390px] items-center gap-2 rounded-2xl border border-grey-midGrey bg-white px-5 py-4 shadow-lg"
>
  <p>
    <span> {{ 'product.licenseInput.label' | transloco }}</span>
    <span
      tabindex="0"
      [matTooltip]="'product.licenseInput.tooltip' | transloco"
      class="cursor-default underline decoration-dotted"
    >
      {{ 'product.licenseInput.users' | transloco }}
    </span>
  </p>
  <button
    class="flex size-11 shrink-0 items-center justify-center rounded-lg bg-grey-lightGrey disabled:opacity-50"
    [disabled]="(quantity && quantity <= min) || disabled"
    (click)="onDecrease()"
  >
    <mat-icon class="hvs-icon-base">remove</mat-icon>
  </button>
  <div
    class="wra flex h-11 items-center gap-1 rounded-lg border border-grey-midGrey p-2"
    tabindex="-1"
  >
    <input
      type="number"
      inputmode="numeric"
      pattern="[0-9]*"
      class="mr-1 w-20 text-right text-lg font-bold focus:outline-none"
      [min]="min"
      [max]="max"
      [disabled]="disabled"
      [value]="quantity"
      (change)="onInputChange($event)"
    />
    <mat-icon class="hvs-icon-base">edit</mat-icon>
  </div>
  <button
    class="flex size-11 shrink-0 items-center justify-center rounded-lg bg-grey-lightGrey disabled:opacity-50"
    [disabled]="(quantity && quantity >= max) || disabled"
    (click)="onIncrease()"
  >
    <mat-icon class="hvs-icon-base">add</mat-icon>
  </button>
</div>
